import { tsValidateIpAddress, tsValidateOptionalId, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { LoginStatus_Failed, LoginStatus_Success } from './types.js';
const Validator_ModifiableProps = {
    accountId: tsValidateUniqueId,
    status: tsValidateValue([LoginStatus_Success, LoginStatus_Failed]),
    metadata: {
        ipAddress: tsValidateIpAddress(false),
        deviceId: tsValidateOptionalId
    }
};
const Validator_GeneratedProps = {};
export const DBDef_LoginAttempt = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'login-attempt',
    entityName: 'login-attempt',
    frontend: {
        group: 'ts-default',
        name: 'login-attempt'
    },
    backend: {
        name: 'user-account--login-attempt'
    }
};
//# sourceMappingURL=db-def.js.map